import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { ChildBioInfo } from './child-bio-info';
export const ChildBioDetailsHeading = t0 => {
  const $ = _c(23);
  const {
    details,
    seoLevel: t1,
    className,
    showIcons: t2
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  const showIcons = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["bio"];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation(t3);
  const {
    hangul,
    name
  } = details;
  const Comp = `h${seoLevel}` as ElementType;
  let t4;
  if ($[1] !== showIcons) {
    t4 = cn("ChildBioDetails__heading", {
      "py-comfy-xs sm:py-0": showIcons
    });
    $[1] = showIcons;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = !showIcons;
  let t6;
  if ($[3] !== className || $[4] !== showIcons || $[5] !== t5) {
    t6 = cn("heading-potent heading-xl", className, {
      "text-center sm:text-left mb-0 sm:mb-comfy-sm py-comfy-xs sm:py-0": showIcons,
      "mb-comfy-sm": t5
    });
    $[3] = className;
    $[4] = showIcons;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      color: "var(--theme-heading-color)"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = hangul.preferred || name.preferred;
  let t9;
  if ($[8] !== name.preferred || $[9] !== t || $[10] !== t8) {
    t9 = t("bio:title", {
      childName: name.preferred,
      koreanName: t8,
      interpolation: {
        escapeValue: false
      }
    });
    $[8] = name.preferred;
    $[9] = t;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== Comp || $[13] !== t6 || $[14] !== t9) {
    t10 = <Comp className={t6} style={t7}>{t9}</Comp>;
    $[12] = Comp;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== details || $[17] !== showIcons) {
    t11 = showIcons && <ChildBioInfo details={details} variant="icons" />;
    $[16] = details;
    $[17] = showIcons;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t4) {
    t12 = <div className={t4}>{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t4;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};